import { getWsHost } from 'Shared/getWsHostName';
import { Websocket } from './Websocket';

export const WEBSOCKETS = {
  dataTS: new Websocket({ url: getWsHost(process.env.REACT_APP_WS_TS_PATH) }),
  terminal: new Websocket({ url: getWsHost(process.env.REACT_APP_WS_TERMINAL_PATH) }),
};

export enum WS_TERMINAL_EVENT_TYPE {
  /** обновляем объект словаря "статусы источника" по пришедшему ``id``, который будет айди источника */
  DATASOURCE_STATUS = 'DATASOURCE_STATUS',
  /** обновляем объект "станции" в словаре станций по пришедшему `id`, который будет айди станции */
  STATION = 'STATION',
  /** обновляем объект словаре "источники" по пришедшему `id`, который будет айди станции */
  DATASOURCE = 'DATASOURCE',
  ACL = 'ACL',
}

export enum WS_TERMINAL_ACTION_TYPE {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export type WsTerminalEventTypes = keyof typeof WS_TERMINAL_EVENT_TYPE
export type WsTerminalActionTypes = keyof typeof WS_TERMINAL_ACTION_TYPE

export type WsTerminalMessageType = {
  /**
   * айди объекта или нужный айди сопутствующий объекту (например, datasourceId для datasourceStatuses),
   * объект для которого надо обновить,
   * т.е. нужно будет сделать запрос по этому айди и обновить то что нужно в зависимости от `type`
   */
  id?: number | string,
  /** тип события, который сообщает объект чего (например, словаря) нужно обновить */
  type: WsTerminalEventTypes,
  // TODO: описать типы взаимодействия со словарями по данным с вебсокета
  action: WsTerminalActionTypes
}
